module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10270.73617011.jpg";